import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import {
  addOrUpdateCart,
  doCartFlush,
  fetchCartList,
  removeItemFromCart,
  orderForSomeOneElse,
  removeSomeOneElse,
} from "./CartApi";
import { CartState } from "../../../features/view/public/shopping/cart/CartTypes";

const initialState: CartState = {
  addTocart: {
    data: [],
    loader: false,
    billingData: {
      subtotal: 0.0,
      taxes_and_charges: 0.0,
      delivery_fee: 0.0,
      grand_total: 0.0,
      total_savings: 0.0,
      coupon_code: "",
      discount: 0.0,
    },
    available_payment_modes: [],
    some_one_else_order: {
      name: "",
      phone_number: "",
    },
    delivery_discount_message: "",
    customization_items: [],
  },
};

export const fetchCartListAsync = createAsyncThunk(
  "cart/get/list",
  async (id: string | null) => {
    const response = await fetchCartList(id);
    return response;
  }
);

export const addOrUpdateCartAsync = createAsyncThunk(
  "cart/add",
  async (payload: any) => {
    const response = await addOrUpdateCart(payload);
    return response;
  }
);

export const removeItemFromCartAsync = createAsyncThunk(
  "cart/delete",
  async (payload: any) => {
    const response = await removeItemFromCart(payload);
    return response;
  }
);
export const cartFlushAsync = createAsyncThunk(
  "cart/flush",
  async (payload: any) => {
    const response = await doCartFlush(payload);
    return response;
  }
);

export const orderForSomeOneElseAsync = createAsyncThunk(
  "orders/add-or-update-someone-else-detail",
  async (payload: any) => {
    const response = await orderForSomeOneElse(payload);
    return response;
  }
);

export const removeSomeOneElseAsync = createAsyncThunk(
  "orders/delete-order-for-someone-else-detail",
  async () => {
    const response = await removeSomeOneElse();
    return response;
  }
);
export const CartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(fetchCartListAsync.pending, (state) => {
        state.addTocart.loader = true;
      })
      .addCase(fetchCartListAsync.fulfilled, (state, action: any) => {
        state.addTocart.loader = false;
        state.addTocart.data = action?.payload?.data?.data || [];
        state.addTocart.available_payment_modes =
          action?.payload?.data?.available_payment_modes || [];
        state.addTocart.billingData = action?.payload?.data?.price_data || {};
        state.addTocart.some_one_else_order =
          action?.payload?.data?.some_one_else_order || {};
        state.addTocart.delivery_discount_message =
          action?.payload?.data?.delivery_discount_message || "";
        state.addTocart.customization_items =
          action?.payload?.data?.customization_items || [];
      })
      .addCase(fetchCartListAsync.rejected, (state) => {
        state.addTocart.loader = false;
      })
      .addCase(addOrUpdateCartAsync.pending, (state) => {
        state.addTocart.loader = true;
      })
      .addCase(addOrUpdateCartAsync.fulfilled, (state, action: any) => {
        state.addTocart.loader = false;
        state.addTocart.data = action?.payload?.data?.data || [];
        state.addTocart.billingData = action?.payload?.data?.price_data || {};
        state.addTocart.delivery_discount_message =
          action?.payload?.data?.delivery_discount_message || "";
        state.addTocart.customization_items =
          action?.payload?.data?.customization_items || [];
      })
      .addCase(addOrUpdateCartAsync.rejected, (state) => {
        state.addTocart.loader = false;
      });
  },
});

export default CartSlice.reducer;
